import React from "react";

const ChatSvg = () => {
  return (
    <>
      <svg
        width="39"
        height="39"
        viewBox="0 0 39 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="Icon"
          d="M10.75 19.5H10.7694M19.5 19.5H19.5194M28.25 19.5H28.2694M19.5 37C29.165 37 37 29.165 37 19.5C37 9.83502 29.165 2 19.5 2C9.83502 2 2 9.83502 2 19.5C2 21.8278 2.45449 24.0494 3.27957 26.081C3.43748 26.4698 3.51643 26.6642 3.55166 26.8214C3.58611 26.9751 3.59872 27.0889 3.59874 27.2464C3.59876 27.4075 3.56952 27.5829 3.51104 27.9337L2.35802 34.8519C2.23728 35.5763 2.17691 35.9385 2.28926 36.2005C2.38759 36.4297 2.57027 36.6124 2.79953 36.7107C3.06146 36.8231 3.42369 36.7627 4.14815 36.642L11.0663 35.489C11.4171 35.4305 11.5925 35.4012 11.7536 35.4013C11.9111 35.4013 12.0249 35.4139 12.1786 35.4483C12.3358 35.4836 12.5302 35.5625 12.919 35.7204C14.9506 36.5455 17.1722 37 19.5 37ZM11.7222 19.5C11.7222 20.0369 11.2869 20.4722 10.75 20.4722C10.2131 20.4722 9.77778 20.0369 9.77778 19.5C9.77778 18.9631 10.2131 18.5278 10.75 18.5278C11.2869 18.5278 11.7222 18.9631 11.7222 19.5ZM20.4722 19.5C20.4722 20.0369 20.0369 20.4722 19.5 20.4722C18.9631 20.4722 18.5278 20.0369 18.5278 19.5C18.5278 18.9631 18.9631 18.5278 19.5 18.5278C20.0369 18.5278 20.4722 18.9631 20.4722 19.5ZM29.2222 19.5C29.2222 20.0369 28.7869 20.4722 28.25 20.4722C27.7131 20.4722 27.2778 20.0369 27.2778 19.5C27.2778 18.9631 27.7131 18.5278 28.25 18.5278C28.7869 18.5278 29.2222 18.9631 29.2222 19.5Z"
          stroke="#20558B"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </svg>
    </>
  );
};

export default ChatSvg;
